
// This is firebase stuff

import firebase from 'firebase'
const config = {
  apiKey: 'AIzaSyDrv83fRdbIbRC5yYxBJKhCHACP-ld4UFI',
  authDomain: 'app-5pani2pesci.firebaseapp.com',
  databaseURL: 'https://app-5pani2pesci.firebaseio.com',
  storageBucket: 'app-5pani2pesci.appspot.com',
  messagingSenderId: '423190157517'
}
firebase.initializeApp(config)

export default firebase

// const db = firebase.initializeApp(config).database()
// export default db

// // in your component:
// import './db'
//
// export default {
//   firebase {
//     example: db.ref('example')
//   }
// }



// WEBPACK FOOTER //
// ./src/modules/firebase.js